import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Divider, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useNotification } from '../../../../../helpers/Notification';
import { LoadingWidget } from '../../../../../widgets';
import BotonComponent from '../../../../dashboard/components/BotonNuevo';
import SelectFieldSeccionesComponent from '../../../secciones/components/SelectFieldSecciones';
import {
  asignarSeccionesDocentesAction,
  deleteSeccionesDocentesAction,
} from '../../DocentesAction';

const SeccionesDocentesComponent = () => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const docentesStore = Redux.useSelector((state) => state.docentes);

  const secciones = docentesStore.activo.secciones;

  const [idSeccion, setIdSeccion] = React.useState('');
  const [loadingDelete, setLoadingDelete] = React.useState(null);

  return (
    <Grid container spacing={1}>
      <LoadingWidget
        isLoading={docentesStore.loadingAll || loadingDelete}
        text={
          loadingDelete ? 'Eliminando asignacion...' : 'Asignando seccion...'
        }
      />
      <Grid item md={8}>
        <SelectFieldSeccionesComponent
          value={idSeccion}
          isAll={false}
          onChange={(idSeccion) => setIdSeccion(idSeccion)}
          selects={secciones}
        />
      </Grid>

      <Grid item md={4} sx={{ display: 'flex' }}>
        <BotonComponent
          click={async () => {
            const res = await asignarSeccionesDocentesAction(
              { dispatch, notify },
              {
                idDocente: docentesStore.activo.id,
                idSeccion,
              },
            );
            if (res) setIdSeccion('');
          }}
          disabled={!idSeccion}
          text="ASIGNAR"
          green
          addIcon
          mr={2}
        />
      </Grid>

      <Grid item md={12}>
        <Divider sx={{ my: 1 }} />
        <Typography variant="h5" color="initial">
          Asignados
        </Typography>
        <TableContainer>
          <Table size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                {loginStore.isRoot ? <TableCell>ID</TableCell> : null}
                <TableCell>Nivel académico</TableCell>
                <TableCell>Sección</TableCell>
                <TableCell>Turno</TableCell>
                <TableCell>Acción</TableCell>
              </TableRow>
            </TableHead>
            {secciones ? (
              <TableBody>
                {secciones.map((el) => (
                  <TableRow
                    key={el.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    {loginStore.isRoot ? <TableCell>{el.id}</TableCell> : null}
                    <TableCell>
                      {el.seccion.nivelAcademico.nivelAcademico.nombre}
                    </TableCell>
                    <TableCell>{el.seccion.nombre}</TableCell>
                    <TableCell>{el.seccion.turno}</TableCell>
                    <TableCell>
                      <Tooltip
                        describeChild
                        title="Eliminar seccion"
                        placement="top"
                      >
                        <IconButton
                          color="error"
                          size="small"
                          aria-label="Eliminar seccion"
                          onClick={async () => {
                            setLoadingDelete(true);
                            await deleteSeccionesDocentesAction(
                              { dispatch, notify },
                              docentesStore.activo.id,
                              el.id,
                            );
                            setLoadingDelete(false);
                          }}
                        >
                          <DeleteForeverIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            ) : null}
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};

export default SeccionesDocentesComponent;
